import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Icon = ({
  size,
  color,
  icon,
}) => (
  <>
    <FontAwesomeIcon icon={icon} size={size} color={color} />
  </>
);

Icon.propTypes = {
  size: PropTypes.string,
  color: PropTypes.string,
  icon: PropTypes.string.isRequired,
};

Icon.defaultProps = {
  size: '1x',
  color: '#fff',
};

export default Icon;
